import { isDiscordURL, isValidURL } from 'helpers';
import { CustomSocialLinksProfile } from '../CustomSocialLinks';

export const Discord: CustomSocialLinksProfile = {
  name: 'discord',
  matches: [
    {
      match: (input: string) => {
        try {
          if(isDiscordURL(input)) {
            const profileId = input.split('/').pop();
            return profileId;
          } else if('https://discordapp.com/users/'.includes(input)){
            return undefined;
          } else if (isValidURL(input))  {
            return undefined;
          } else {
            return input;
          }
        } catch {
          return undefined;
        }
      },
      pattern: 'https://discordapp.com/users/{PROFILE_ID}',
      type: 0
    }
  ]
};
